// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cU","reportCardBox":"cU","report-img-wrap":"cV","reportImgWrap":"cV","report-title":"cW","reportTitle":"cW","report-date":"cX","reportDate":"cX"};